export default function HoneyBot({ state, setHoneyBotValue, _id }) {
	return (
		<div className="input-wrap">
			<input
				type="text"
				id={`element-special_input-${state.id}-${_id}`}
				value={state.value}
				onInput={event => setHoneyBotValue(event.target.value)}
				onChange={event => setHoneyBotValue(event.target.value)}
			/>
		</div>
	);
}
